// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { DocumentModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import constants from "@store/constants";
import useParentProductState from "@store/Framework/Store/Foundation/Data/Products/ProductsHooks/useParentProductState";
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";
import IFrame from "@store/Library/Components/Foundation/IFrame";
import * as React from "react";

interface OwnProps extends WidgetProps, HasProduct {
    extendedStyles?: EmbededVideoStyles;
}

export interface EmbededVideoStyles {
    videoGridItem?: GridItemProps;
}

export const embededVideoStyles: EmbededVideoStyles = {
    videoGridItem: {
        width: [12, 12, 12, 12, 12],
    },
};

const EmbededVideoWidget: React.FC<OwnProps> = ({ extendedStyles, product: { documents } }) => {
    const [styles] = React.useState(() => mergeToNew(embededVideoStyles, extendedStyles));

    const parentProductState = useParentProductState();

    const videos = documents?.filter(x => x.documentType === constants.documentTypes.videos);
    const parentVideos = parentProductState?.documents?.filter(x => x.documentType === constants.documentTypes.videos);

    if ((!videos || videos.length === 0) && (!parentVideos || parentVideos?.length === 0)) {
        return <>{translate("No Video Available")}</>;
    }

    const displayVideo = (document: DocumentModel) => {
        return (
            <GridItem {...styles.videoGridItem} key={document.id.toString()}>
                <IFrame src={document.filePath} iFrameRatio="35%" />
            </GridItem>
        );
    };

    return (
        <GridContainer>
            {videos?.length
                ? videos.map(document => displayVideo(document))
                : parentVideos?.map(document => displayVideo(document))}
        </GridContainer>
    );
};

const widgetModule: WidgetModule<FoundationFieldDefinition> = {
    component: withProduct(EmbededVideoWidget),
    definition: {
        group: "Product Details",
        displayName: "Embeded Product Video",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
